import "./profileinformations.css";
import API from "../../../API";
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { useTranslation } from 'react-i18next';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  FaUser, FaMapMarkerAlt, FaBirthdayCake, FaMap, FaVenusMars, FaCheckCircle
} from "react-icons/fa";

const Gender = {
  MALE: "MALE",
  FEMALE: "FEMALE",
};

export default function Profileinformations({ userData, onUpdate }) {
  const { t } = useTranslation(); // Initialize the translation hook

  const wilayas = [
    { value: "Adrar", label: "Adrar" },
    { value: "Chlef", label: "Chlef" },
    { value: "Laghouat", label: "Laghouat" },
    { value: "Oum El Bouaghi", label: "Oum El Bouaghi" },
    { value: "Batna", label: "Batna" },
    { value: "Béjaïa", label: "Béjaïa" },
    { value: "Biskra", label: "Biskra" },
    { value: "Béchar", label: "Béchar" },
    { value: "Blida", label: "Blida" },
    { value: "Bouira", label: "Bouira" },
    { value: "Tamanrasset", label: "Tamanrasset" },
    { value: "Tébessa", label: "Tébessa" },
    { value: "Tlemcen", label: "Tlemcen" },
    { value: "Tiaret", label: "Tiaret" },
    { value: "Tizi Ouzou", label: "Tizi Ouzou" },
    { value: "Alger", label: "Alger" },
    { value: "Djelfa", label: "Djelfa" },
    { value: "Jijel", label: "Jijel" },
    { value: "Sétif", label: "Sétif" },
    { value: "Saïda", label: "Saïda" },
    { value: "Skikda", label: "Skikda" },
    { value: "Sidi Bel Abbès", label: "Sidi Bel Abbès" },
    { value: "Annaba", label: "Annaba" },
    { value: "Guelma", label: "Guelma" },
    { value: "Constantine", label: "Constantine" },
    { value: "Médéa", label: "Médéa" },
    { value: "Mostaganem", label: "Mostaganem" },
    { value: "M'Sila", label: "M'Sila" },
    { value: "Mascara", label: "Mascara" },
    { value: "Ouargla", label: "Ouargla" },
    { value: "Oran", label: "Oran" },
    { value: "El Bayadh", label: "El Bayadh" },
    { value: "Illizi", label: "Illizi" },
    { value: "Bordj Bou Arréridj", label: "Bordj Bou Arréridj" },
    { value: "Boumerdès", label: "Boumerdès" },
    { value: "El Tarf", label: "El Tarf" },
    { value: "Tindouf", label: "Tindouf" },
    { value: "Tissemsilt", label: "Tissemsilt" },
    { value: "El Oued", label: "El Oued" },
    { value: "Khenchela", label: "Khenchela" },
    { value: "Souk Ahras", label: "Souk Ahras" },
    { value: "Tipaza", label: "Tipaza" },
    { value: "Mila", label: "Mila" },
    { value: "Aïn Defla", label: "Aïn Defla" },
    { value: "Naâma", label: "Naâma" },
    { value: "Aïn Témouchent", label: "Aïn Témouchent" },
    { value: "Ghardaïa", label: "Ghardaïa" },
    { value: "Relizane", label: "Relizane" },
  ];

  const genderOptions = [
    { value: Gender.MALE, label: "Male" },
    { value: Gender.FEMALE, label: "Female" },
  ];

  const formatDateString = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleInputChange = (field) => (event) => {
    const { value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const [formData, setFormData] = useState({
    firstname: userData?.firstname || "",
    lastname: userData?.lastname || "",
    birthplace: userData?.birthplace || "",
    birthdate: userData?.birthdate || "",
    wilaya: userData?.wilaya || "",
    gender: userData?.gender || "",
  });

  useEffect(() => {
    if (userData) {
      setFormData({
        firstname: userData.firstname || "",
        lastname: userData.lastname || "",
        birthplace: userData.birthplace || "",
        birthdate: userData.birthdate || "",
        wilaya: userData.wilaya || "",
        gender: userData.gender || "",
      });
    }
  }, [userData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("protoken");

    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const updatedData = {
        ...formData,
        birthdate: formData.birthdate ? new Date(formData.birthdate).toISOString() : null,
      };

      await API.patch(`/users/${userId}`, updatedData, config);
      Swal.fire({
        icon: "success",
        title: t("profileinformations.success_title"),
        text: t("profileinformations.success_message"),
      }).then(() => {
        window.location.href = "/profile";  // Redirect after success alert
      });
    } catch (error) {
      console.error("Error updating user data:", error);

      Swal.fire({
        icon: "error",
        title: t("profileinformations.error_title"),
        text: t("profileinformations.error_message"),
      });
    }
  };

  return (
    <form className="pi-form" onSubmit={handleSubmit}>
      <header className="pi-head">
        <div>
          <span className="pi-eyebrow">
            <FaUser /> {t("profileinformations.title")}
          </span>
          <p className="pi-sub">
            Manage how your name, date of birth and region appear on your bookings.
          </p>
        </div>
      </header>

      <div className="pi-grid">
        <div className="pi-field">
          <label className="pi-label">
            <FaUser className="pi-label-ico" />
            {t("profileinformations.firstname_label")}
          </label>
          <input
            type="text"
            className="pi-input"
            placeholder={t("profileinformations.firstname_placeholder")}
            name="firstname"
            value={formData.firstname}
            onChange={handleChange}
          />
        </div>

        <div className="pi-field">
          <label className="pi-label">
            <FaUser className="pi-label-ico" />
            {t("profileinformations.lastname_label")}
          </label>
          <input
            type="text"
            className="pi-input"
            placeholder={t("profileinformations.lastname_placeholder")}
            name="lastname"
            value={formData.lastname}
            onChange={handleChange}
          />
        </div>

        <div className="pi-field">
          <label className="pi-label">
            <FaMapMarkerAlt className="pi-label-ico" />
            {t("profileinformations.birthplace_label")}
          </label>
          <input
            type="text"
            className="pi-input"
            placeholder={t("profileinformations.birthplace_placeholder")}
            name="birthplace"
            value={formData.birthplace}
            onChange={handleChange}
          />
        </div>

        <div className="pi-field">
          <label className="pi-label">
            <FaBirthdayCake className="pi-label-ico" />
            {t("profileinformations.birthdate_label")}
          </label>
          <div className="pi-date">
            <DatePicker
              selected={formData.birthdate ? new Date(formData.birthdate) : null}
              onChange={(date) =>
                setFormData((prev) => ({
                  ...prev,
                  birthdate: date ? formatDateString(date) : '',
                }))
              }
              dateFormat="yyyy-MM-dd"
              placeholderText="YYYY-MM-DD"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              openToDate={formData.birthdate ? new Date(formData.birthdate) : new Date(2000, 0, 1)}
              minDate={new Date(1900, 0, 1)}
              maxDate={new Date()}
              className="pi-input"
            />
          </div>
        </div>

        <div className="pi-field">
          <label className="pi-label">
            <FaMap className="pi-label-ico" />
            {t("profileinformations.wilaya_label")}
          </label>
          <select
            className="pi-select"
            name="wilaya"
            value={formData.wilaya || ""}
            onChange={handleChange}
          >
            <option value="" disabled>
              {t("profileinformations.wilaya_placeholder")}
            </option>
            {wilayas.map((w) => (
              <option key={w.value} value={w.value}>{w.label}</option>
            ))}
          </select>
        </div>

        <div className="pi-field">
          <label className="pi-label">
            <FaVenusMars className="pi-label-ico" />
            {t("profileinformations.gender_label")}
          </label>
          <select
            className="pi-select"
            name="gender"
            value={formData.gender || ""}
            onChange={handleChange}
          >
            <option value="" disabled>
              {t("profileinformations.gender_placeholder")}
            </option>
            {genderOptions.map((g) => (
              <option key={g.value} value={g.value}>{g.label}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="pi-actions">
        <button type="submit" className="pi-submit">
          <FaCheckCircle /> {t("profileinformations.update_button")}
        </button>
      </div>
    </form>
  );
}